module.exports = __webpack_public_path__ + "static/img/gxhdbg.4c61f51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation/gxhdbg.png
// module id = OYuQ
// module chunks = 36